import { Deserializable } from '../_common/deserializable';

export class PremiumServiceMeta implements Deserializable{
    id: number;
    name: string;
    description: string;
    createdAt: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }

}
